<template>
<div>
  <div id="musiclist">
    <P>#musiclist</P>
    <div class="container">
      <div class="mu-control">Control Bar
        <p>Shuffled Play (Not work yet)</p>
        <p>Ordered Play (Not work yet)</p>
      </div>
      <div class="mu-list">
        <div v-for="item in muList" :key="item.filename">
          <muPlay :vo="item"
          @playPause="playStop(item)"
          @playPosition="playPosition(item,...arguments)"
          @download="downloadMusic(item)"></muPlay>
          </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import papa from 'papaparse';
import muPlay from './muPlay.vue'
import audio5 from 'audio5';
const a5js = new audio5({});
import downfile from 'djs'

export default {
  components:{muPlay},
  props: ['twins'],
  data(){
    return {
      muList: [],
      currentMusicPosition: 0,
      currentMusicDuration: 0,
      currentMusicIndex: 0,
    }
  },
  mounted(){
    const me = this;
    me.twins[0].pID.forEach(prefixID => {
      var sheetpath = "/static/sheets/"+prefixID+".csv"
      papa.parse(sheetpath,{
        download: true,
        header: true,
        dynamicTyping: true,
        encoding: "UTF-8",
        complete: function(result){
          let orderNumber = 0;
          result.data.forEach(e => {
            e.urlOGG = "https://vo.kaikai.info/p"+e.pID+"/"+encodeURI(e.filename)+"."+e.ext;
            e.playMP3 = "https://vo.kaikai.info/p"+e.pID+"/"+encodeURI(e.filename)+".mp3";
            e.position = 0;
            e.duration = 0;
            e.playing = 0;
            e.order = orderNumber++;
            me.muList.push(e);
          });
        }
      });
    });
  },
  methods:{
    playStop(item){
      let timeCalc = function(time){
        let hms = time.split(":");
        return hms.reduce((base,add)=>parseInt(base) * 60 + parseInt(add),0);
      }
      if(item.playing){
        a5js.pause();
        item.playing = 0;
      }else{
        this.muList.forEach(e=>{
          e.playing = 0;
        });
        this.currentMusicIndex = item.order;
        item.playing = 1;
        a5js.one("canplay",function () {
          a5js.play();
          },this);
        a5js.on('timeupdate',function (pos,dur) {
          this.currentMusicPosition = timeCalc(pos);
          this.currentMusicDuration = timeCalc(dur);
        },this);
        a5js.load(item.playMP3);
      }
      
    },
    playPosition(item,clickPos,divLength){
      console.log("playPosition",item,clickPos,divLength)
    },
    downloadMusic(item){
      downfile(item.urlOGG);
    }
  },
  watch:{
    currentMusicDuration: function (){
      this.muList[this.currentMusicIndex].duration = this.currentMusicDuration;
      this.muList[this.currentMusicIndex].position = this.currentMusicPosition;
    },
    currentMusicPosition: function (){
      this.muList[this.currentMusicIndex].duration = this.currentMusicDuration;
      this.muList[this.currentMusicIndex].position = this.currentMusicPosition;
    },
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
#herovoice{
  background: rgba(255, 255, 255, 0.5);
}
.titleBoard{
  cursor: pointer;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  .name {
    font-size: 2.6em;
    font-weight: 500;
  }
  .name.active {
    text-shadow: 0px 1px 2px #fff,
    0px -1px 2px #fff,
    1px 0px 2px #fff,
    -1px 0px 2px #fff;
  }
}
.vo-list{
  color: #fff;
  display: flex;
  flex-direction: column;
  .label{
    display: flex;
    .labelName{
      display: inline-block;
      color:#fff;
      background:#333;
      padding:2px 8px;
      border-radius: 4px;
      text-align: left;
    }
    .labellist{
      display: flex;
      flex-wrap: wrap;
    }
  }
}
.left, .right{
  width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/musiclist.vue